export default "__VITE_ASSET__D_JI1RUX__"